import React from 'react';
import { useNavigate } from 'react-router-dom';

import { routeCreator as productGroupRouteCreator } from '@occc-app/routes/ProductGroup/utils';
import { ProductGroupFragment } from '@occc/graphql';
import { ChipBox } from '@occc-app/design-system';

export type ProductGroupsChipBoxProps = {
  productGroups: ProductGroupFragment[];
};

export const ProductGroupsChipBox = ({ productGroups }: ProductGroupsChipBoxProps) => {
  const navigate = useNavigate();

  const onProductGroupClick = React.useCallback(
    (productGroupId: string) => {
      navigate(productGroupRouteCreator.details(productGroupId));
    },
    [navigate],
  );

  return <ChipBox items={productGroups} onClick={onProductGroupClick} p={0} m={0} />;
};
